// deps
import React, { memo } from "react";

// internal-deps
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

// constants
import { TURBO_WALLET_BALANCE_TEXT } from "@payment-ui/constants/TurboPayment";
import { ACCESSIBILITY_ROLES } from "@payment-ui/constants";

// styles
import { Container, NameWrapper, BalanceText, InlineBalanceContainer, TruncatedText, Name } from "./styles";
import { TURBO_PAYMENT_METHOD_WIDGET_DATA_TEST_IDS } from "@swiggy-private/payment-test-ids";
import { CardNumberSubname } from "@payment-ui/widgets/payment-method-name/v4/components/card-number-subname";

interface ITurboPaymentDisplayNameProps {
    superScriptText?: string;
    ariaLabel?: string;
    displayName: string;
    inlineBalanceMeta?: {
        show: boolean;
        value?: string | number;
    };
    cardSubName?: string;
}

function TurboPaymentDisplayName(props: ITurboPaymentDisplayNameProps) {
    const { ariaLabel, displayName, inlineBalanceMeta, cardSubName } = props;

    return (
        <Container>
            <NameWrapper aria-label={ariaLabel} tabIndex={0} role={ACCESSIBILITY_ROLES.GENERIC}>
                <Name
                    data-testid={TURBO_PAYMENT_METHOD_WIDGET_DATA_TEST_IDS.DISPLAY_NAME}
                    variant="V2.body2.neutral.bold"
                    color="text_High_Emphasis"
                >
                    <TruncatedText>{displayName}</TruncatedText>
                </Name>
                {cardSubName && (
                    <CardNumberSubname
                        textVariant="V2.body3.neutral.medium"
                        textColor="text_Highest_Emphasis"
                        dotLength={2}
                        cardNumber={cardSubName}
                        isTurboPaymentMethod={true}
                        isTurboV2={true}
                    />
                )}
            </NameWrapper>
            {inlineBalanceMeta?.show && inlineBalanceMeta.value && (
                <InlineBalanceContainer
                    data-testid={TURBO_PAYMENT_METHOD_WIDGET_DATA_TEST_IDS.INLINE_BALANCE_CONTAINER}
                >
                    <Text variant="V2.body3.neutral.regular" color="text_Med_Emphasis">
                        {TURBO_WALLET_BALANCE_TEXT}
                    </Text>
                    <BalanceText variant="V2.body3.neutral.regular" color="text_Med_Emphasis">
                        {String(inlineBalanceMeta.value)}
                    </BalanceText>
                </InlineBalanceContainer>
            )}
        </Container>
    );
}

export default memo(TurboPaymentDisplayName);
